// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { createPageElement } from "@insite/client-framework/Components/ContentItemStore";
import { ShellContext, useShellContext } from "@insite/client-framework/Components/IsInShell";
import { loadPageByType } from "@insite/client-framework/Store/Data/Pages/PagesActionCreators";
import { getPageStateByType } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC, useEffect } from "react";

export interface OnePageCheckoutProductListOverlayProps {}

const OnePageCheckoutProductListOverlay: FC<OnePageCheckoutProductListOverlayProps> = () => {
    const dispatch = useAppDispatch();
    const { isInShell } = useShellContext();
    const {
        cartSettings: { onePageCheckout },
    } = useSettingsCollection();
    const overlayState = useAppSelector(state => getPageStateByType(state, "OnePageCheckoutProductListOverlay"));
    const overlay = overlayState.value || nullPage;
    const { isLoading } = overlayState;

    useEffect(() => {
        if (overlay === nullPage && !isLoading) {
            dispatch(loadPageByType("OnePageCheckoutProductListOverlay"));
        }
    }, []);

    if (!onePageCheckout || overlay === nullPage) {
        return null;
    }

    return (
        <ShellContext.Provider value={{ isInShell, pageId: overlay.id }}>
            {createPageElement(overlay.type, overlay)}
        </ShellContext.Provider>
    );
};

export default OnePageCheckoutProductListOverlay;
